import { PathNormalize } from "./Util/pathNormalize";
/**
 * Reference file resolver
 *
 * This class is used to resolve the file from the path
 *
 * It's responsibility is similar to a file system
 */
export class ReferenceFileResolver {
    /**
     * File list that can be resolved
     */
    files;
    _rootUrl;
    _fileRootId;
    _fileMap = new Map();
    /**
     * Create a reference file resolver
     *
     * File root id can be root url, and becomes id for formats where texture is included in binary files, such as BPMX
     * @param files File list
     * @param rootUrl Root url for trim the path of the files
     * @param fileRootId File root id for give the unique id for the files
     */
    constructor(files, rootUrl, fileRootId) {
        this.files = files;
        this._rootUrl = PathNormalize(rootUrl);
        this._fileRootId = fileRootId;
        if (files.length === 0)
            return;
        if (files[0] instanceof File) {
            for (const file of files) {
                const fileRelativePath = PathNormalize(file.webkitRelativePath);
                const relativePath = fileRootId + PathNormalize(fileRelativePath);
                this._fileMap.set(PathNormalize(relativePath).toUpperCase(), file);
            }
        }
        else {
            for (const file of files) {
                const relativePath = fileRootId + PathNormalize(this._rootUrl + file.relativePath);
                this._fileMap.set(PathNormalize(relativePath).toUpperCase(), file);
            }
        }
    }
    /**
     * Create full path from relative path for resolve the file
     * @param relativePath Relative path
     * @returns Full path
     */
    createFullPath(relativePath) {
        return this._fileRootId + PathNormalize(this._rootUrl + relativePath);
    }
    /**
     * Resolve the file from the path
     * @param path Path
     * @returns File
     */
    resolve(path) {
        const finalPath = PathNormalize(path);
        return this._fileMap.get(finalPath.toUpperCase());
    }
}
